import { render, staticRenderFns } from "./ParseList.vue?vue&type=template&id=3c53f3f7&scoped=true&"
import script from "./ParseList.vue?vue&type=script&lang=js&"
export * from "./ParseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53f3f7",
  null
  
)

export default component.exports